import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=701ac82d&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=701ac82d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ac82d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701ac82d')) {
      api.createRecord('701ac82d', component.options)
    } else {
      api.reload('701ac82d', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=701ac82d&scoped=true&", function () {
      api.rerender('701ac82d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modal.vue"
export default component.exports